import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./component/scrollToTop/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";

// Service
import ServiceOne from "./pages/ServiceOne";
import ServiceTwo from "./pages/ServiceTwo";
import ServiceDetails from "./pages/ServiceDetails";

// Pages
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import ErrorPage from "./pages/404";

// Css Import
import "./assets/scss/app.scss";
import FAQs from "./pages/FAQs";
import RequestQuote from "./pages/RequestAQuote";

import ClientPortfolio from "./pages/ClientPortfolio";
import MissionVision from "./pages/MissionVision";
import Gallery from "./pages/Gallery";
import Certification from "./pages/Certification";
import HealthSafety from "./pages/HealthSafety";

import Careers from "./pages/Careers";
import EstimateProject from "./pages/EstimateProject";

import Industry from "./pages/Industry";
import Sustainability from "./pages/Sustainability";
import SmartTech from "./pages/SmartTech";
import MainLayout from "./component/mainlayout/MainLayout";
import Home from "./pages/Home";
import WhoWeAre from "./pages/WhoWeAre";
import CookiePolicyPage from "./pages/CookiePolicyPage";

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <MainLayout>
          <Routes>
            {/* home page */}
            <Route path={process.env.PUBLIC_URL + "/"} element={<Home />} />

            {/* who we are page*/}
            <Route
              path={process.env.PUBLIC_URL + "/who-we-are"}
              element={<WhoWeAre />}
            />

            {/* mission vision page*/}
            <Route
              path={process.env.PUBLIC_URL + "/mission-vision"}
              element={<MissionVision />}
            />

            {/* testimonials page*/}
            <Route
              path={process.env.PUBLIC_URL + "/testimonials"}
              element={<Testimonials />}
            />

            {/* gallery page */}
            <Route
              path={process.env.PUBLIC_URL + "/gallery"}
              element={<Gallery />}
            />

            {/* health safety page */}
            <Route
              path={process.env.PUBLIC_URL + "/health-safety"}
              element={<HealthSafety />}
            />

            {/* sustainability page */}
            <Route
              path={process.env.PUBLIC_URL + "/sustainability"}
              element={<Sustainability />}
            />

            {/* smart tech page */}
            <Route
              path={process.env.PUBLIC_URL + "/smart-tech"}
              element={<SmartTech />}
            />

            {/* services page */}
            <Route
              path={process.env.PUBLIC_URL + "/services"}
              element={<ServiceOne />}
            />

            {/* service dynamic page (eg:- ifm-services, hard-services, soft-services, security-services, specialized-services) */}
            <Route
              path={process.env.PUBLIC_URL + "/service/:slug"}
              element={<ServiceTwo />}
            />

            {/* service details page */}
            <Route
              path={process.env.PUBLIC_URL + "/service/:category/:service"}
              element={<ServiceDetails />}
            />

            {/* industries we serve page */}
            <Route
              path={process.env.PUBLIC_URL + "/industry"}
              element={<Industry />}
            />

            {/* client portfolio page */}
            <Route
              path={process.env.PUBLIC_URL + "/client-portfolio"}
              element={<ClientPortfolio />}
            />

            {/* accreditation page */}
            <Route
              path={process.env.PUBLIC_URL + "/accreditations"}
              element={<Certification />}
            />

            {/* contact page */}
            <Route
              path={process.env.PUBLIC_URL + "/contact-us"}
              element={<Contact />}
            />

            {/* request quote page */}
            <Route
              path={process.env.PUBLIC_URL + "/request-quote"}
              element={<RequestQuote />}
            />

            {/* faqs page */}
            <Route path={process.env.PUBLIC_URL + "/faqs"} element={<FAQs />} />

            {/* careers page */}
            <Route
              path={process.env.PUBLIC_URL + "/careers"}
              element={<Careers />}
            />

            {/* cookie policy page */}
            <Route
              path={process.env.PUBLIC_URL + "/cookie-policy"}
              element={<CookiePolicyPage />}
            />

            {/* estimate project page */}
            <Route
              path={process.env.PUBLIC_URL + "/estimate-project"}
              element={<EstimateProject />}
            />

            {/* error page */}
            <Route
              path={process.env.PUBLIC_URL + "/404"}
              element={<ErrorPage />}
            />
          </Routes>
        </MainLayout>
      </ScrollToTop>
    </Router>
  );
};

export default App;
